module.exports = __webpack_public_path__ + "img/X-ray.5f371bb5.png";